import {
    array,
    assign,
    enums,
    literal,
    nullable,
    number,
    object,
    string,
    union,
} from "superstruct";

import { REWARDS_SPENDING_RULES_REDEEM_REWARD_TYPES } from "../constants";

const RewardsSpendingRuleRedeemRewardTypeSchema = enums(
    Object.values(REWARDS_SPENDING_RULES_REDEEM_REWARD_TYPES)
);

//Base redeem schema
const RewardsSpendingRuleBaseRedeemSchema = object({
    rewardId: string(),
    rewardCode: string(),
    rewardType: RewardsSpendingRuleRedeemRewardTypeSchema,
});

//Base redeem reward schema
const RewardsSpendingRuleBaseRedeemRewardSchema = object({
    type: RewardsSpendingRuleRedeemRewardTypeSchema,
    id: string(),
    code: string(),
    title: string(),
});

//Discount life time schema
const RewardsSpendingRulesDiscountLifeTimeSchema = object({
    startsAt: string(),
    endsAt: nullable(string()),
});

//Amount discount redeem schema
const RewardsSpendingRulesAmountDiscountRedeemSchema = assign(
    RewardsSpendingRuleBaseRedeemSchema,
    object({
        reward: assign(
            RewardsSpendingRuleBaseRedeemRewardSchema,
            RewardsSpendingRulesDiscountLifeTimeSchema,
            object({
                type: literal(
                    REWARDS_SPENDING_RULES_REDEEM_REWARD_TYPES.amountDiscount
                ),
                amount: number(),
                currencyCode: string(),
            })
        ),
    })
);

//Percentage redeem schema
const RewardsSpendingRulesPercentageDiscountRedeemSchema = assign(
    RewardsSpendingRuleBaseRedeemSchema,
    object({
        reward: assign(
            RewardsSpendingRuleBaseRedeemRewardSchema,
            RewardsSpendingRulesDiscountLifeTimeSchema,
            object({
                type: literal(
                    REWARDS_SPENDING_RULES_REDEEM_REWARD_TYPES.percentageDiscount
                ),
                percents: number(),
            })
        ),
    })
);

//Gift card redeem schema
const RewardsSpendingRuleGiftCardRedeemSchema = assign(
    RewardsSpendingRuleBaseRedeemSchema,
    object({
        reward: assign(
            RewardsSpendingRuleBaseRedeemRewardSchema,
            object({
                type: literal(
                    REWARDS_SPENDING_RULES_REDEEM_REWARD_TYPES.giftCard
                ),
                balance: number(),
                initialValue: number(),
                currencyCode: string(),
                expiresAt: nullable(string()),
            })
        ),
    })
);

//Free shipping redeem schema
const RewardsSpendingRuleFreeShippingRedeemSchema = assign(
    RewardsSpendingRuleBaseRedeemSchema,
    object({
        reward: assign(
            RewardsSpendingRuleBaseRedeemRewardSchema,
            RewardsSpendingRulesDiscountLifeTimeSchema,
            object({
                type: literal(
                    REWARDS_SPENDING_RULES_REDEEM_REWARD_TYPES.shippingDiscount
                ),
                countryCodes: array(string()),
            })
        ),
    })
);

//Free product redeem schema
const RewardsSpendingRuleFreeProductRedeemSchema = assign(
    RewardsSpendingRuleBaseRedeemSchema,
    object({
        reward: assign(
            RewardsSpendingRuleBaseRedeemRewardSchema,
            RewardsSpendingRulesDiscountLifeTimeSchema,
            object({
                type: literal(
                    REWARDS_SPENDING_RULES_REDEEM_REWARD_TYPES.productDiscount
                ),
                productId: number(),
                variantId: number(),
                amount: number(),
                percents: number(),
                currencyCode: string(),
            })
        ),
    })
);

export const RewardsSpendingRulesRedeemSchema = union([
    RewardsSpendingRulesAmountDiscountRedeemSchema,
    RewardsSpendingRulesPercentageDiscountRedeemSchema,
    RewardsSpendingRuleGiftCardRedeemSchema,
    RewardsSpendingRuleFreeShippingRedeemSchema,
    RewardsSpendingRuleFreeProductRedeemSchema,
]);
